import React from 'react'
import { Link } from 'react-router-dom'

const PreviousBtn = ({ previousDisabled, previousLink }) => {
    if (previousDisabled) {
        return (
            <button className="btn question-btn question-btn--disabled">
                <svg className="back" width="30px" height="14px" viewBox="0 0 30 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <path d="M1.78885438,6.10557281 L12.5527864,0.723606798 C13.0467649,0.476617549 13.6474379,0.676841896 13.8944272,1.17082039 C13.9638549,1.30967583 14,1.46278889 14,1.61803399 L14,6 L30,6 C30.5522847,6 31,6.44771525 31,7 C31,7.55228475 30.5522847,8 30,8 L14,8 L14,12.381966 C14,12.9342508 13.5522847,13.381966 13,13.381966 C12.8447549,13.381966 12.6916418,13.3458209 12.5527864,13.2763932 L1.78885438,7.89442719 C1.29487588,7.64743794 1.09465154,7.0467649 1.34164079,6.5527864 C1.43840449,6.359259 1.59532698,6.20233651 1.78885438,6.10557281 Z"></path>
                </svg>
                <p>Prev</p>
            </button>
        )
    } else {
        return (
            <Link className="btn question-btn" to={ previousLink }>
                <svg className="back" width="30px" height="14px" viewBox="0 0 30 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <path d="M1.78885438,6.10557281 L12.5527864,0.723606798 C13.0467649,0.476617549 13.6474379,0.676841896 13.8944272,1.17082039 C13.9638549,1.30967583 14,1.46278889 14,1.61803399 L14,6 L30,6 C30.5522847,6 31,6.44771525 31,7 C31,7.55228475 30.5522847,8 30,8 L14,8 L14,12.381966 C14,12.9342508 13.5522847,13.381966 13,13.381966 C12.8447549,13.381966 12.6916418,13.3458209 12.5527864,13.2763932 L1.78885438,7.89442719 C1.29487588,7.64743794 1.09465154,7.0467649 1.34164079,6.5527864 C1.43840449,6.359259 1.59532698,6.20233651 1.78885438,6.10557281 Z"></path>
                </svg>
                <p>Prev</p>
            </Link>
        )
    }
}

export default PreviousBtn


// WEBPACK FOOTER //
// ./src/components/PreviousBtn.js